<template>
  <div class="d-flex m-auto">
    <vue-ellipse-progress
      :progress="percent"
      :size="40"
      :thickness="5"
      emptyThickness="12%"
      color="rgb(39, 189, 167)"
      emptyColor="#dbdbdb"
      reverse
      fontColor="#1085ff"
      :legend="false"
    >
      <span slot="legend-caption" class="legend-caption my-2">
        {{ percent | numeral("0,0.00") }}%
      </span>
    </vue-ellipse-progress>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      required: true,
      type: String | Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-caption {
  font-size: 9px;
}

::v-deep .ep-legend--container {
  top: 5px;
}
</style>